import React, { useState, useEffect } from "react";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import { getData } from "../api/protectedApi";
import ReactPaginate from "react-paginate";
import "../style.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const DirectTeamTable = () => {
  const [teamData, setTeamData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const perPage = 5;

  const getDirectsList = async (page = 0) => {
    try {
      const res = await getData(
        `/directs?per_page=${perPage}&page=${page + 1}`
      );

      setTeamData(res.data.data || []);
      setTotalPages(Number(res.data.pagination.total_pages || 0));
      setCurrentPage(page);
    } catch (err) {
      console.error("Error fetching directs:", err);
    }
  };

  useEffect(() => {
    getDirectsList(0);
  }, []);

  const handlePageClick = (event) => {
    getDirectsList(event.selected);
  };

  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        color: "#fff",
        padding: "12px 0",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* NAVBAR */}
      <DashboardNavbar />

      <section>
        <div className="container">
          <div className="directs-wrapper">
            <div className="directs-title">My Directs</div>

            <div className="table-responsive">
              <table className="table directs-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>User ID</th>
                    <th>Package</th>
                    <th>Business</th>
                    <th>Activation Time</th>
                  </tr>
                </thead>

                <tbody>
                  {teamData.length > 0 ? (
                    teamData.map((item, index) => (
                      <tr key={index}>
                        <td>{currentPage * perPage + index + 1}</td>
                        <td>{item.user_id}</td>
                        <td>{item.package}</td>
                        <td>{item.business}</td>
                        <td>{item.registration_date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* PAGINATION */}
            {totalPages > 1 && (
              <ReactPaginate
                previousLabel={<FaChevronLeft />}
                nextLabel={<FaChevronRight />}
                pageCount={totalPages}
                onPageChange={handlePageClick}
                forcePage={currentPage}          
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                containerClassName="pagination custom-pagination justify-content-center mt-4"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                nextClassName="page-item"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                activeClassName="active"
                disabledClassName="disabled"     
              />
            )}

          </div>
        </div>
      </section>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default DirectTeamTable;
